<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择员工"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  queryStaffInfo,
} from 'api/car';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'linkman',
      tableSelectTar: 'loginAcct',
      searchBoxDataTmpl: {
        form: [
          { // 手机号码
            label: '手机号码',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入手机号码',
          },
          { // 员工姓名
            label: '员工姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入员工姓名',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'customerCode',
          label: '司机姓名',
        },
        {
          prop: 'companyName',
          label: '司机手机',
        },
      ],
      tableTitle: [
        {
          prop: 'loginAcct',
          label: '登录手机',
        },
        {
          prop: 'linkman',
          label: '员工姓名',
        },
      ],
    };
  },
  methods: {
    getListApi: queryStaffInfo,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
